export const dashboard = {
  statistics: "products/store/dashboard/",
  analytics: "products/store/dashboard/analytics/",
};
